export const reduceSetErrorsAsShown = (state) => {
  return {
    ...state,
    shown: true,
  };
};
